import { AdminAppState, AdminPanelsState } from '../../state';

export const getAdminPanelsState = (store: AdminAppState): AdminPanelsState =>
  store.panels;
